<script setup lang="ts">
import {Plus} from "@element-plus/icons-vue";
import {ref} from "vue";
import {genFileId, UploadProps, UploadRequestOptions, UploadUserFile} from "element-plus";
import {uploadImage} from "@/utils/cos.ts";
import {ProgressInfo} from "cos-js-sdk-v5";

const fileList = ref<UploadUserFile[]>([]);
const previewVisible = ref(false)
const previewList = ref<string[]>([])

const handlePreview: UploadProps['onPreview'] = (uploadFile) => {
  previewVisible.value = true
  previewList.value = [uploadFile.url!]
}

const upload = (options: UploadRequestOptions) => {
  if (options.file) {
    uploadImage(options.file, {
      onTaskReady: (taskId: string) => {
        console.log(taskId)
        fileList.value = fileList.value.map((item) => {
          if (item.uid === options.file.uid) {
            item.status = "uploading"
          }
          return item
        })
      },
      onProgress: (progressData: ProgressInfo) => {
        console.log(progressData.percent)
        fileList.value = fileList.value.map((item) => {
          if (item.uid === options.file.uid) {
            item.percentage = progressData.percent * 100
          }
          return item
        })
      },
      onUploadFail: (err: string) => {
        console.log("图片上传失败:", err)
        fileList.value = fileList.value.map((item) => {
          if (item.uid === options.file.uid) {
            item.status = "fail"
          }
          return item
        })
      },
      onFileFinish: (url: string) => {
        console.log("图片上传成功:", url)
        fileList.value = fileList.value.map((item) => {
          if (item.uid === options.file.uid) {
            item.url = url
            item.status = "success"
          }
          return item
        })
      }
    })
  }
}

// 初始化图片列表
const init = (thumb: string) => {
  if (thumb) {
    fileList.value = [{
      uid: genFileId(),
      name: "图片",
      url: thumb,
      status: "success"
    }]
  } else {
    fileList.value = []
  }
}

defineExpose({
  init,
  fileList
})
</script>

<template>
  <div>
    <el-upload
        v-model:file-list="fileList"
        :class="(fileList && fileList.length > 0) ? `hide_box` : ``"
        list-type="picture-card"
        :http-request="upload"
        :on-preview="handlePreview"
        accept=".jpg,.jpeg,.png"
        :limit="1"
    >
      <el-icon>
        <Plus />
      </el-icon>
    </el-upload>
  </div>
  <el-image-viewer @close="previewVisible = false" :url-list="previewList" v-if="previewVisible"/>
</template>

<style scoped>
.hide_box ::v-deep(.el-upload--picture-card) {
  display: none;
}
</style>
